<template>
  <vx-card no-shadow>

    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <vs-button class="mr-4 sm:mb-0 mb-2" @click="BeginUploadPhoto()">Upload photo</vs-button>
        <!-- <vs-button type="border" color="danger">Remove</vs-button> -->
        <p class="text-sm mt-2">Please upload a square PNG or JPG image</p>
      </div>
    </div>

    <!-- Info -->
    <!-- <vs-input class="w-full mb-base" label-placeholder="Username" v-model="username"></vs-input> -->
    <vs-input disabled class="w-full mb-base" label-placeholder="Name" v-model="name"></vs-input>
    <!-- <vs-input class="w-full" label-placeholder="Email" v-model="email"></vs-input> -->

    <!-- <vs-alert icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
      <span>Your account is not verified. <a href="#" class="hover:underline">Resend Confirmation</a></span>
    </vs-alert> -->

    <!-- <vs-input disabled class="w-full my-base" label-placeholder="Company" v-model="company"></vs-input> -->

    <!-- Save & Reset Button -->
    <!-- <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div> -->

  	<!-- @cancel="CancelTimeEntryPrompt"
			@accept="AcceptTimeEntryPrompt"
			@close="CancelTimeEntryPrompt" -->
    <!-- FILE UPLOAD MODAL -->
		<vs-prompt 
			color="primary"
			title="Upload Image"
		
			:active.sync="uploadModalActive">
			<div class="con-exemple-prompt">

          <vs-upload multiple="false" limit="1" :headers="userAvatarUploadHeaders" :action="userAvatarUploadURL" fileName="WorkerAvatar" @on-success="SuccessUpload" />

        
			</div>
     </vs-prompt>
	 <!-- END FILE UPLOAD MODAL -->


  </vx-card>
</template>

<script>

import axios from '../../axios.js'
import Vue from 'vue'
export default {
  data () {
    return {
      username: 'johny_01',
      name: this.$store.state.AppActiveUser.displayName,
      email: 'john@admin.com',
      company: 'SnowMash Technologies Pvt Ltd',
      uploadStatus: 0, //0 is hasn't started, 1 is success, 2 = fail
      uploadModalActive: false
    }
  },
  computed: {
    photoURL () {
      return this.$store.state.photoURL
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    userAvatarUploadURL () {
      return `${process.env.VUE_APP_AXIOS_BASE_URL }/account/workeravatar`
    },
    userAvatarUploadHeaders () {
      const accessToken = this.$store.state.tokens.accessToken
     
      const headers = {
        'authorization': accessToken,
        'simulation': this.$store.state.simulation
        //'Content-Type': 'application/json; charset=UTF-8'
      }
      return headers
    }
    
  },
  methods:{
    
    SuccessUpload (data) {
      console.log('Success')
      data = JSON.parse(data.currentTarget.response)
      console.log(data)
      const avatarData = `data:image/jpeg;base64,${  Buffer.from(data[0].WorkerAvatar.data, 'binary').toString('base64')}`
      this.$store.commit('SetUserProfileImage', avatarData)
      this.$vs.notify({color:'success', title:'Upload Success', text:'Your avatar was updated!'})
    },
    BeginUploadPhoto () {
      this.uploadModalActive = true
    }
  }
}
</script>
